module.exports = __webpack_public_path__ + "static/media/house12.d17d7f02.png";